import { render, staticRenderFns } from "./BaseRealname.vue?vue&type=template&id=7532c725&scoped=true"
import script from "./BaseRealname.vue?vue&type=script&lang=js"
export * from "./BaseRealname.vue?vue&type=script&lang=js"
import style0 from "./BaseRealname.vue?vue&type=style&index=0&id=7532c725&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7532c725",
  null
  
)

export default component.exports